import { useRef, useEffect } from 'react'
import { useCityContext } from '@contexts/LocationContext'
import Button from '@components/Button'
import './LocationSelector.css'

const LocationSelector = ({ onClose }) => {
  const { city, cities, changeCity } = useCityContext()
  const modalRef = useRef()

  useEffect(() => {
    const handleClickOutside = (event) => {
      // If the modal is open and the click is outside the modal content, close it.
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [onClose]); // Dependency on onClose to re-create effect if it changes

  const handleSelectCity = (citySlug) => {
    changeCity(citySlug)
    onClose()
  }

  // The retryDetection and loading are removed from here as the city detection is now URL-based.
  // The functionality to "detect my location" would need to be re-evaluated if desired.

  return (
    <div className="location-selector"> {/* This div now acts purely as an overlay, clicks outside modal content will be handled by useEffect */}
      <div className="location-selector__modal" ref={modalRef}> {/* Attach ref here */}
        <div className="location-selector__header">
          <h2 className="location-selector__title">Selecione sua cidade</h2>
          <button className="location-selector__close" onClick={onClose} aria-label="Fechar">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="18" y1="6" x2="6" y2="18"/>
              <line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
          </button>
        </div>

        <div className="location-selector__content">

          <div className="location-selector__divider">
            <span>ou selecione</span>
          </div>

          <div className="location-selector__cities">
            {cities.map((c) => (
              <button
                key={c.slug}
                className={`location-selector__city ${city?.slug === c.slug ? 'location-selector__city--active' : ''}`}
                onClick={() => handleSelectCity(c.slug)}
              >
                <div className="location-selector__city-info">
                  <span className="location-selector__city-name">{c.name}</span>
                  <span className="location-selector__city-state">{c.state}</span>
                </div>
                <div 
                  className="location-selector__city-color"
                  style={{ 
                    backgroundColor: c.slug === 'uberlandia' ? '#f97316' : '#eab308'
                  }}
                />
                {city?.slug === c.slug && (
                  <svg className="location-selector__city-check" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
                    <polyline points="20 6 9 17 4 12"/>
                  </svg>
                )}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default LocationSelector
